(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this._scrollAccum = 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Use the header's live offsetHeight as the threshold rather than
      // headerBounds.bottom from the IntersectionObserver, which can be stale
      // on first paint and produce unreliable hide/reveal mid-page.
      const threshold = this.header.offsetHeight;
      const delta = scrollTop - this.currentScrollTop;

      // At the very top → reset to natural state, clear any accumulator.
      if (scrollTop <= 1) {
        this._scrollAccum = 0;
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        this.currentScrollTop = scrollTop;
        return;
      }

      // Below the header threshold → no sticky behaviour yet.
      if (scrollTop <= threshold) {
        this.currentScrollTop = scrollTop;
        return;
      }

      this.header.classList.add('scrolled-past-header');

      // Directional deadband: absorb sub-8px scroll noise (trackpad inertia,
      // touch elasticity near videos) so the header only commits to a
      // hide/reveal after meaningful movement in one direction.
      const DEADBAND = 8;

      if (delta > 0) {
        // Scrolling DOWN — reset accumulator if we just changed direction.
        if (this._scrollAccum < 0) this._scrollAccum = 0;
        this._scrollAccum += delta;
        if (this._scrollAccum >= DEADBAND) {
          this._scrollAccum = 0;
          if (!this.preventHide) {
            requestAnimationFrame(this.hide.bind(this));
          }
        }
      } else if (delta < 0) {
        // Scrolling UP — reset accumulator if we just changed direction.
        if (this._scrollAccum > 0) this._scrollAccum = 0;
        this._scrollAccum += delta; // negative
        if (this._scrollAccum <= -DEADBAND) {
          this._scrollAccum = 0;
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      // Note: do NOT add 'animate' here. On the first hide (from natural document
      // flow), adding `position: sticky; top: 0` snaps the header to the viewport
      // top — if `animate` were on, the transform would then animate from 0 to
      // -100% and the user would see the header momentarily pop back into view.
      // Without `animate`, the sticky-position snap and the transform are
      // composited in a single paint and the transition is invisible.
      // On subsequent hides (after a reveal), `animate` is already present from
      // the reveal() call, so the cinematic slide-up still plays.
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('header-shadow-active');
      if (this.shadowTimer) clearTimeout(this.shadowTimer);
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      // Cinematic touch: pulse a subtle blurred line below the header on reveal.
      this.header.classList.add('header-shadow-active');
      if (this.shadowTimer) clearTimeout(this.shadowTimer);
      this.shadowTimer = setTimeout(() => {
        this.header.classList.remove('header-shadow-active');
      }, 720);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'header-shadow-active');
      if (this.shadowTimer) clearTimeout(this.shadowTimer);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
